import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import block from 'bem-cn';

import { clearPaymentLink } from 'features/payment/redux/actions';
import usePaymentFrame from 'features/payment/model/paymentPaykassma/usePaymentFrame';

import './PaymentFramePage.scss';

const b = block('paykassma-frame-page');

const PaymentFramePage = ({ type = 'withdrawal', amount, phone }) => {
  const dispatch = useDispatch();

  const { containerRef, isPaymentLoading, paymentLink } = usePaymentFrame({ type, amount, phone });

  useEffect(() => {
    return () => {
      dispatch(clearPaymentLink());
    };
  }, [dispatch]);

  return (
    <div className={b('frame-container')}>
      {paymentLink && (
        <iframe
          ref={containerRef}
          src={paymentLink}
          title="Payment Frame"
          style={{ width: '100%', height: '100%', border: 'none' }}
        />
      )}
    </div>
  );
};

export default PaymentFramePage;
